<!-- Your HTML template -->
<div class="modal-header">
    <div class="col-md-6 col-5 col-lg-3">
        <h4 class="card-title m-0"><i class="ft-user-plus mr-1"></i>Ledgers</h4>
    </div>
    <div class="col-md-4">
        <!-- <select class="form-select fileld" id="entry-account">
            <option hidden value="" disabled selected>Choose...</option>
            <option *ngFor="let account of accounts" [ngValue]="account.id">{{account.name}}</option>
        </select> -->
    </div>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<section id="extended">
    <div class="row">
        <div class="col-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body table-responsive">
                        <!-- Display your ledger data as needed -->
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Journal</th>
                                    <th>Entry</th>
                                    <th>Credit Amount</th>
                                    <th>Debit Amount</th>
                                    <th>Reference</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ ledger.date || 'N/A' }}</td>
                                    <td>{{ ledger.journal || 'N/A' }}</td>
                                    <td>{{ ledger.entry || 'N/A' }}</td>
                                    <td>{{ ledger.creditAmount || 'N/A' }}</td>
                                    <td>{{ ledger.debitAmount || 'N/A' }}</td>
                                    <td>{{ ledger.reference || 'N/A' }}</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>